"use strict";

try {
  angular.module("norgrenApp", ["ngComponentRouter", "tc.chartjs", "ui.bootstrap", "ngMap"]);
} catch (err) {
  console.log("norgrenApp NOT Loaded | " + err);
} //# sourceURL=norgrenApp.module.js